export default {
  getPages() {
    return ApiClient.get("publisher/api/pages");
  },
  publishPage(name, eventId) {
    return ApiClient.post("publisher/api/pages", { name, eventId });
  },
  unpublishPage(name) {
    return ApiClient.delete(`publisher/api/pages/${name}`);
  },
};
